import React from 'react'

function Mechanical() {
  return (
    <div></div>
  )
}

export default Mechanical
